import { axios } from '@/utils/request'

const api = {
  Pre: '/teacher.php/Bill/pre',
  List: '/teacher.php/Bill/getList',
  Detail: '/teacher.php/Bill/detail',
  Done: '/teacher.php/Bill/done',
  OrderList: '/teacher.php/Bill/orderList',
  SubscribeList: '/teacher.php/Bill/subscribeList'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function getDetail (parameter) {
  return axios({
    url: api.Detail,
    method: 'get',
    params: {
      bill_id: parameter
    }
  })
}

export function doneBill (parameter) {
  return axios({
    url: api.Done,
    method: 'post',
    data: parameter
  })
}

export function orderList (parameter) {
  return axios({
    url: api.OrderList,
    method: 'get',
    params: parameter
  })
}

export function subscribeList (parameter) {
  return axios({
    url: api.SubscribeList,
    method: 'get',
    params: parameter
  })
}
